{
  "BUSINESS_NUMBER": {
    "TITLE": "Vul uw dossiernummer in om te starten",
    "INSTRUCTION_FORMAT": "Formaat: minimaal 7 cijfers.",
    "PLACEHOLDER": "Bv.: 1234567",
    "ERROR_INVALID_FORMAT": "Het dossiernummer moet uit minstens 7 cijfers bestaan."
  },
  "BUTTON": {
    "VALIDATE": "Bevestigen",
    "VALIDATE_MY_CHOICES": "Mijn keuzes bevestigen"
  },
  "CONFIRM_DIALOG": {
    "VALIDATE": "Bevestigen",
    "CANCEL": "Annuleren"
  },
  "FOOTER": {
    "COPYRIGHT_NOTICE": "© {{ year }} EVOQ {{ brandLabel }}. Alle rechten voorbehouden."
  },
  "FREE_ROAM": {
    "CREATIVE_SUGGESTION": "Om uw 3D-scène te wijzigen en een ultra-realistisch beeld te krijgen, kunt u overwegen specifieke elementen toe te voegen zoals: een aangrenzende kamer, een stijl, decoratie-elementen, een moment van de dag... Laat uw creativiteit de vrije loop!",
    "TYPE_TEXT_HERE": "Typ hier uw tekst (minimaal 100 tekens)",
    "VISUAL_IMPROVEMENT_DESCRIPTION": "Gelieve de verbeteringen te beschrijven die u aan uw afbeelding wilt aanbrengen"
  },
  "GENERATION_RESULT": {
    "COPIED_CONFIRMATION": "Gekopieerd!",
    "COPY_PROMPT": "De prompt kopiëren",
    "ENLARGE_IMAGE": "Vergroten",
    "DOWNLOAD_IMAGE": "Afbeelding downloaden",
    "DOWNLOAD_VIDEO": "Video downloaden",
    "EDIT_PROMPT": "De prompt bewerken",
    "EVOQ_PROPOSED_VISUAL": "Hier is de afbeelding voorgesteld door Evoq",
    "EVOQ_PROPOSED_VISUALS": "Hier zijn de afbeeldingen voorgesteld door Evoq",
    "GENERATE_VIDEO": "Video genereren",
    "GENERATION_ERROR_RETRY": "Er is een fout opgetreden tijdens het genereren. Probeer het opnieuw.",
    "SERVER_BUSY_ERROR": "Onze servers zijn momenteel zwaar belast. Probeer het over enkele ogenblikken opnieuw.",
    "RETRY_ACTION": "Opnieuw proberen",
    "PROCESSING_VIDEOS_COUNT": "{{ processingVideoCount }} video's in behandeling",
    "REGENERATE_ACTION": "Opnieuw genereren",
    "REMAINING_IMAGES": "Resterende afbeeldingen:",
    "REMAINING_VIDEOS": "Resterende video's:",
    "VIDEO_CREATION_IN_PROGRESS": "Video wordt gemaakt",
    "WAIT_MOMENT_MESSAGE": "Even geduld a.u.b..."
  },
  "GUIDED_TOUR": {
    "ANSWER": {
      "ROOM_BATHROOM": "Badkamer",
      "ROOM_BEDROOM": "Slaapkamer",
      "ROOM_DINING": "Eetkamer",
      "ROOM_DRESSING": "Dressing",
      "ROOM_ENTRANCE": "Inkom",
      "ROOM_KITCHEN": "Keuken",
      "ROOM_LAUNDRY": "Wasplaats",
      "ROOM_LIVING": "Woonkamer",
      "ROOM_NO": "Nee",
      "ROOM_OFFICE": "Bureau",
      "ROOM_PANTRY": "Berging",
      "STYLE_CONTEMPORARY": "Hedendaags",
      "STYLE_COUNTRY": "Landelijk",
      "STYLE_COZY": "Cosy",
      "STYLE_DESIGN": "Design",
      "STYLE_HIGH_END": "High-end",
      "STYLE_INDUSTRIAL": "Industrieel",
      "STYLE_MODERN": "Modern",
      "STYLE_RUSTIC": "Rustiek",
      "STYLE_SCANDINAVIAN": "Scandinavisch",
      "STYLE_WOOD": "Hout",
      "TIME_AFTERNOON": "Namiddag",
      "TIME_EVENING": "Avond",
      "TIME_MORNING": "Ochtend",
      "TIME_NONE": "Geen",
      "TIME_NOON": "Middag"
    },
    "FORM": {
      "ENTER_ELEMENT": "Voer een element in"
    },
    "QUESTION": {
      "ADJOINING_ROOM": "Wilt u een aangrenzende kamer opnemen in uw hoofdplan?",
      "APPLY_STYLE": "Welke stijl wilt u toepassen op uw scène?",
      "DECORATION_ELEMENTS": "Welke essentiële decoratie-elementen wilt u toevoegen?",
      "MAIN_ROOM_SELECTION": "Welke hoofdruimte wilt u behandelen?",
      "TIME_OF_DAY": "Naar welk moment van de dag wilt u verwijzen?"
    }
  },
  "HEADER": {
    "BUDGET_THIS_MONTH": "Verbruikt budget deze maand (schatting)",
    "DASHBOARD": "Dashboard",
    "FREE_CREDITS": "Gratis credits",
    "FREE_CREDITS_LABEL": "gratis credits",
    "IMAGES_THIS_MONTH": "Afbeeldingen gegenereerd deze maand",
    "LOGOUT": "Afmelden",
    "NEW_PROJECT": "Nieuw project",
    "THIS_MONTH": "Deze maand",
    "VIDEOS_THIS_MONTH": "Video's gegenereerd deze maand"
  },
  "IMAGE_UPLOAD": {
    "ACCEPTED_FORMATS": "Toegestane formaten: PNG of JPEG.",
    "ALL_CREDITS_USED": "U hebt al uw credits gebruikt",
    "BLOCKED_GENERIC": "Het genereren van beelden is tijdelijk niet beschikbaar.",
    "BLOCKED_NO_QUOTA": "Er is geen Evoq-quotum ingesteld voor uw account.",
    "BLOCKED_QUOTA_MONTHLY": "Uw maandelijkse Evoq-quotum is opgebruikt. Neem contact op met uw verantwoordelijke.",
    "BLOCKED_QUOTA_ROLLING": "Uw Evoq-quotum is opgebruikt.",
    "BLOCKED_QUOTA_ROLLING_UNTIL": "Uw Evoq-quotum is opgebruikt. U kunt opnieuw genereren vanaf {{ date }}.",
    "BLOCKED_UNAVAILABLE": "Niet beschikbaar",
    "CATALOG_ONLY_NOTICE": "Opmerking: Elk element in uw scène wordt niet getransformeerd door de AI, maar verbeterd voor een realistisch resultaat.",
    "FILE_SIZE_LIMIT": "De bestandsgrootte mag niet meer dan {{ size }} MB bedragen",
    "FREE_IMAGE_GENERATION": "Vrije afbeeldingsgeneratie",
    "GUIDED_IMAGE_GENERATION": "Begeleide afbeeldingsgeneratie",
    "IMPORT_ROOM_VISUAL": "Uw afbeelding importeren",
    "INSUFFICIENT_DIMENSIONS": "Onvoldoende afmetingen (min. {{ minWidth }} x {{ minHeight }} px)",
    "INVALID_FORMAT": "Ongeldig formaat (alleen PNG of JPEG)",
    "LIGHTING_WARNING": "<strong>Belangrijk:</strong> gebruik een plan zonder lichteffecten om AI-hallucinaties te voorkomen.",
    "MINIMUM_IMAGE_DIMENSIONS": "Minimale afmetingen voor upload: {{ minWidth }} x {{ minHeight }} pixels.",
    "NO_MORE_CREDIT": "Geen credits meer",
    "UNREADABLE_FILE": "Bestand kan niet worden gelezen",
    "UPLOAD_ROOM_VISUAL": "Laad het beeld van uw kamer om te beginnen"
  },
  "LOGIN": {
    "AUTHENTICATING_MESSAGE": "Even geduld terwijl we uw gegevens ophalen...",
    "AUTHENTICATING_TITLE": "Authenticatie bezig",
    "AUTO_LOGIN_FOURNIER": "Automatisch aanmelden Fournier",
    "AUTO_LOGIN_FRANCHISEE": "Automatisch aanmelden Franchisenemer",
    "CHOOSE_SPACE_INSTRUCTION": "Kies uw ruimte om door te gaan",
    "ERROR_FRANCHISE_MISSING_STORE_MESSAGE": "Uw account is niet gekoppeld aan een winkel. Maak een Easy Vista-ticket aan om deze informatie aan te vullen en probeer het opnieuw.",
    "ERROR_FRANCHISE_MISSING_STORE_TITLE": "Aanmelden niet mogelijk",
    "ERROR_MESSAGE": "Er is een fout opgetreden bij het ophalen van uw gegevens. Probeer het opnieuw.",
    "ERROR_TITLE": "Authenticatiefout",
    "RETRY_BUTTON": "Opnieuw proberen",
    "WELCOME_MESSAGE": "Welkom bij Evoq"
  },
  "DASHBOARD": {
    "TITLE": "Dashboard",
    "NAV": {
      "OVERVIEW": "Overzicht",
      "VENDORS": "Team",
      "BILLING_HISTORY": "Facturatiegeschiedenis"
    },
    "OVERVIEW": {
      "TITLE": "Overzicht",
      "MANAGE": "Beheren",
      "PLACEHOLDER": {
        "TITLE": "Binnenkort beschikbaar",
        "DESCRIPTION": "Het overzicht van uw activiteit wordt momenteel vernieuwd."
      }
    },
    "VENDORS": {
      "TITLE": "Teambeheer",
      "PHYSICAL": {
        "SUBTITLE": "Activeer of zeg het abonnement van elke verkoper van uw team op.",
        "COUNTER_ACTIVE": "Actieve abonnees",
        "COUNTER_NONE": "Zonder abonnement",
        "COUNTER_CANCELLING": "Opzegging gepland",
        "TABLE_TITLE": "Verkopers",
        "COST_HINT": "Kosten van het abonnement: {{price}} / maand / verkoper",
        "COST_UNAVAILABLE": "Tarieven niet beschikbaar",
        "COL_VENDOR": "Verkoper",
        "COL_STATUS": "Status",
        "COL_ACTION": "Actie",
        "SELECT_ALL": "Alles selecteren",
        "SELECT_ROW": "{{name}} selecteren",
        "SELECT_ROW_DISABLED": "{{name}} kan niet worden geselecteerd",
        "STATUS_SUBSCRIBED": "Geabonneerd",
        "STATUS_NONE": "Zonder abonnement",
        "STATUS_CANCELLING": "Opzegging gepland",
        "CANCELLING_EFFECT": "Ingaand op {{date}}",
        "FREE_CREDITS": "Gratis credits: {{count}} / {{total}} resterend",
        "ACTION_ACTIVATE": "Abonnement activeren",
        "ACTION_CANCEL": "Opzeggen",
        "ACTION_REACTIVATE": "Opzegging annuleren",
        "SELECTED_ONE": "verkoper geselecteerd",
        "SELECTED_OTHER": "verkopers geselecteerd",
        "BULK_ACTIVATE": "Abonnement activeren",
        "BULK_CLEAR": "Alles deselecteren",
        "EMPTY": "Geen verkopers in dit team.",
        "LOADING": "Laden...",
        "ENGAGEMENT_NOTE": "Abonnement vastgelegd tot het einde van het kalenderkwartaal, elk kwartaal automatisch verlengd tenzij opgezegd; de opzegging gaat in aan het einde van het kwartaal.",
        "CONFIRM_ACTIVATE_TITLE": "Abonnement activeren",
        "CONFIRM_ACTIVATE_BODY": "{{name}}, {{price}} / maand. Abonnement vastgelegd tot het einde van het kalenderkwartaal, daarna elk kwartaal automatisch verlengd tenzij opgezegd.",
        "CONFIRM_ACTIVATE_OK": "Activeren",
        "DESK_REQUEST_TITLE": "Om een abonnement te activeren, dient u een aanvraag in via een Desk-ticket",
        "DESK_REQUEST_PATH": "Desk → Een Fournier Retail Desk-ticket aanmaken, Rubriek \"Service\"",
        "DESK_CLOSE": "Sluiten",
        "CANCEL": "Annuleren",
        "CONFIRM_CANCEL_TITLE": "Abonnement opzeggen",
        "CONFIRM_CANCEL_BODY": "Ingaand op {{date}} (einde van het lopende kwartaal). {{name}} behoudt tot dan toegang.",
        "CONFIRM_CANCEL_OK": "Opzeggen",
        "CONFIRM_REACTIVATE_TITLE": "Opzegging annuleren",
        "CONFIRM_REACTIVATE_BODY": "Het abonnement van {{name}} loopt normaal door.",
        "CONFIRM_REACTIVATE_OK": "Bevestigen",
        "CONFIRM_REACTIVATE_BACK": "Terug",
        "BULK_CONFIRM": "Activering bevestigen",
        "BULK_UNIT_COST": "Kosten per eenheid",
        "BULK_ENGAGEMENT": "Verbintenis",
        "BULK_ENGAGEMENT_VALUE": "Tot het einde van het kwartaal",
        "BULK_TOTAL": "Maandtotaal",
        "TOAST_ACTIVATED": "Abonnement geactiveerd voor {{name}}",
        "TOAST_CANCELLED": "Opzegging gepland voor {{name}}",
        "TOAST_REACTIVATED": "Opzegging geannuleerd voor {{name}}",
        "TOAST_BULK_ONE": "Abonnement geactiveerd voor 1 verkoper",
        "TOAST_BULK_OTHER": "Abonnement geactiveerd voor {{count}} verkopers",
        "TOAST_ERROR": "Er is een fout opgetreden, probeer het opnieuw."
      }
    },
    "BILLING_HISTORY": {
      "TITLE": "Facturatiegeschiedenis",
      "BADGE": "abonnementen",
      "INTRO": "Facturatie van de abonnementen van uw team, maandelijks gefactureerd en gegroepeerd per kwartaal. Voor elke maand: het aantal actieve abonnementen en de bijbehorende kosten.",
      "KPI_TOTAL_YEAR": "Totaal {{ year }}",
      "KPI_TOTAL_YEAR_TO_DATE": "Totaal {{ year }} tot nu toe",
      "KPI_CURRENT_QUARTER": "Lopend kwartaal",
      "KPI_LAST_QUARTER": "Laatste kwartaal",
      "CARD_TITLE": "Maandelijkse facturatie",
      "YEAR_SELECTOR_LABEL": "Jaarkeuze",
      "STATUS_IN_PROGRESS": "Lopend kwartaal",
      "STATUS_CHARGED": "Gefactureerd",
      "SUBTOTAL": "Subtotaal",
      "TOTAL": "Totaal",
      "NOTE": "Maandelijkse factuur, uitgereikt voor de afgelopen maand en gegroepeerd per kalenderkwartaal (T1 jan.-mrt, T2 apr.-jun, T3 jul.-sep., T4 okt.-dec.). Elk in de maand actief abonnement wordt voor de volledige maand gefactureerd, zonder pro rata. Het tarief en de maandelijkse kosten worden door de facturatie geleverd."
    },
    "CONSUMPTION": {
      "TITLE": "Verbruik van het team",
      "VENDOR": "Lid",
      "IMAGE": "Afbeelding",
      "VIDEO": "Video",
      "REMAINING": "Rest: {{ value }}",
      "REMAINING_WITH_FREE": "Rest: {{ total }} waarvan {{ free }} gratis",
      "NO_VENDORS": "Nog geen leden"
    },
    "ALLOCATION": {
      "CANNOT_GENERATE": "Kan niet genereren",
      "QUOTA_HIDDEN_NOTICE": "Het quotum wordt hier door de manager ingesteld. Voor de gebruiker blijft het onzichtbaar: de verkoper ziet alleen zijn verbruik en zijn budget.",
      "IMAGE_QUOTA": "Afbeeldingsquota",
      "VIDEO_QUOTA": "Videoquota",
      "APPLY": "Toepassen",
      "SAVING": "Opslaan...",
      "SAVE_QUOTAS": "Quota's opslaan",
      "SAVE_SUCCESS": "De quota's zijn succesvol bijgewerkt",
      "IMAGE": "Afbeelding",
      "VIDEO": "Video",
      "CONSUMPTION": "Verbruik",
      "MONTHLY_QUOTA": "Maandelijks Quotum",
      "FREE_CREDITS": "Gratis",
      "REMAINING": "Rest: {{ value }}"
    },
    "PACKS": {
      "FILTER_ALL": "Alle",
      "FILTER_IMAGES": "Afbeeldingen",
      "FILTER_VIDEOS": "Video's",
      "FILTER_MIXED": "Gemengd",
      "PRICE_PER_IMAGE": "Dat is {{ price }} per afbeelding",
      "PRICE_PER_VIDEO": "Dat is {{ price }} per video",
      "CREDITS": "Kredieten",
      "IMAGES": "Afbeeldingen",
      "VIDEO": "Video",
      "CHOOSE_PACK": "Dit pakket kiezen"
    },
    "BILLING_HISTORY_TABLE": {
      "MONTH": "Maand",
      "ACTIVE_SUBSCRIPTIONS": "Actieve abonnementen",
      "MONTHLY_COST": "Maandelijkse kosten",
      "EMPTY_TITLE": "Geen facturatie",
      "EMPTY_MESSAGE": "De facturatiegeschiedenis van uw abonnementen verschijnt hier."
    },
    "USAGE_HISTORY": {
      "BADGE": "per gebruiker",
      "INTRO": "Maandelijks verbruik per gebruiker en de bijbehorende kost.",
      "KPI_TOTAL_MONTH": "Totaal",
      "KPI_LAST_3_MONTHS": "Laatste 3 maanden",
      "NOTE": "Verbruik gefactureerd per kwartaal (huidige maand en de twee voorgaande). De kost van elke maand wordt vastgelegd op het moment van verbruik."
    },
    "USAGE_HISTORY_TABLE": {
      "CARD_TITLE": "Detail per gebruiker",
      "USER": "Gebruiker",
      "IMAGES": "Afbeeldingen",
      "VIDEOS": "Video's",
      "COST": "Kost",
      "MONTH_SELECTOR_LABEL": "Maandkeuze",
      "TOTAL": "Totaal",
      "EMPTY_TITLE": "Geen verbruik",
      "EMPTY_MESSAGE": "De verbruiksgeschiedenis van uw team verschijnt hier."
    }
  },
  "STORE_SELECTION": {
    "TITLE": "Selecteer uw winkel",
    "SUBTITLE": "Kies de winkel die u wilt beheren",
    "SEARCH_PLACEHOLDER": "Zoeken op naam, ID, merk…",
    "SEARCH_SHORT": "Zoeken…",
    "ALL_BRANDS": "Alle merken",
    "ALL_TYPES": "Alle typen",
    "RESULTS": "resultaten",
    "STORES_LINKED": "winkels gekoppeld aan uw account",
    "NO_RESULTS": "Geen winkels gevonden",
    "SEE_ALL": "Alle winkels bekijken",
    "SWITCH_STORE": "Van winkel wisselen",
    "TYPE": {
      "PHYSICAL": "Fysiek",
      "VIRTUAL": "Virtueel"
    },
    "TABLE": {
      "STORE": "Winkel",
      "STORE_ID": "Winkel-ID",
      "BRAND": "Merk",
      "TYPE": "Type",
      "ACTION": "Actie",
      "SELECT_STORE": "{{ name }} selecteren"
    }
  }
}
